<template>
  <footer class="the-footer flex-wrap justify-between"></footer>
</template>

<script>
export default {};
</script>